import { useState } from "react";
import { Download, Eye, FileArchive, FileText, Loader2, Trash2 } from "lucide-react";
import { DOC_TYPE_OPTIONS } from "./docTypes";
import { ClientPicker } from "../loans/ClientPicker";
import { ArchiveTag } from "../ArchiveTag";
import { isArchive } from "../../lib/files";
import { formatSize } from "../../lib/format";

export const PendingFileRow = ({ f, onAssign, onView, onDownload, onDiscard }) => {
  const pre = f.suggested_borrower_id
    ? { borrower_id: f.suggested_borrower_id, name: f.suggested_client_name, persona: f.suggested_client_persona, persona_label: f.suggested_client_persona === "PM" ? "Persona moral" : "Persona física" }
    : null;
  const [client, setClient] = useState(pre);
  const [docType, setDocType] = useState("");
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const options = DOC_TYPE_OPTIONS.filter(([k]) => client?.persona === "PM" || k !== "pm_acta");
  const assign = async () => {
    setBusy(true);
    try { await onAssign(f, client, docType); } finally { setBusy(false); }
  };
  return (
    <li className="space-y-3 rounded-[12px] border border-[#e8edf5] bg-[#fbfcfe] p-3" data-testid={`bandeja-file-${f.id}`}>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex min-w-0 items-start gap-2.5">
          {isArchive(f.filename) ? <FileArchive className="mt-0.5 h-4 w-4 shrink-0 text-[#0f5ef7]" /> : <FileText className="mt-0.5 h-4 w-4 shrink-0 text-[#0f5ef7]" />}
          <div className="min-w-0">
            <div className="flex min-w-0 items-center gap-2">
              <div className="truncate text-sm font-semibold text-[#182235]" data-testid={`bandeja-file-name-${f.id}`}>{f.filename}</div>
              {isArchive(f.filename) && <ArchiveTag testId={`bandeja-file-archive-tag-${f.id}`} />}
            </div>
            <div className="break-all font-mono text-[11px] text-[#5b667a]" data-testid={`bandeja-file-path-${f.id}`}>{f.path}</div>
            <div className="text-xs font-semibold text-[#7a5b10]" data-testid={`bandeja-file-reason-${f.id}`}>{f.reason} · {formatSize(f.size)}</div>
            {f.ai_reason && <div className="text-xs text-[#0f5ef7]" data-testid={`bandeja-file-ai-reason-${f.id}`}>IA: {f.ai_reason}{f.ai_proposal ? " · Cliente propuesto, pendiente de confirmar" : ""}</div>}
          </div>
        </div>
        <div className="flex flex-wrap gap-1.5">
          <button type="button" onClick={() => setOpen((o) => !o)} className="tr-btn-light px-2.5 py-1.5 text-xs" data-testid={`bandeja-file-toggle-${f.id}`}>{open ? "Cerrar" : "Asignar…"}</button>
          {f.viewable && <button type="button" onClick={() => onView(f)} className="tr-btn-light px-2.5 py-1.5 text-xs" data-testid={`bandeja-file-view-${f.id}`}><Eye className="h-3.5 w-3.5" /> Ver</button>}
          {onDownload && <button type="button" onClick={() => onDownload(f)} className="tr-btn-light px-2.5 py-1.5 text-xs" data-testid={`bandeja-file-download-${f.id}`}><Download className="h-3.5 w-3.5" /> Descargar</button>}
          <button type="button" onClick={() => onDiscard(f)} className="tr-btn-danger px-2.5 py-1.5 text-xs" data-testid={`bandeja-file-discard-${f.id}`}><Trash2 className="h-3.5 w-3.5" /> Descartar</button>
        </div>
      </div>
      {open && <div className="grid grid-cols-1 gap-2 md:grid-cols-[1fr_220px_auto] md:items-start">
        <ClientPicker value={client} onChange={setClient} testPrefix={`bandeja-file-client-${f.id}`} />
        <select value={docType} onChange={(e) => setDocType(e.target.value)} className="tr-input" data-testid={`bandeja-file-type-${f.id}`} aria-label="Tipo de documento">
          <option value="">Tipo de documento…</option>
          {options.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
        </select>
        <button type="button" onClick={assign} disabled={!client || !docType || busy} className="tr-btn-primary h-11 px-4 text-sm" data-testid={`bandeja-file-assign-${f.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Asignar"}
        </button>
      </div>}
    </li>
  );
};
